<template>
  <v-card-text v-if="cargo && trip">
    <div class="py-0">
      <v-row>
        <v-col cols="12" md="2">
          <z-country-select
            :label="$i18n.t('PickUp Country')"
            v-model="cargo.src.country"
          />
        </v-col>
        <v-col cols="12" md="2">
          <z-city-select
            :label="$i18n.t('PickUp City')"
            v-model="cargo.src.city"
            :country="cargo.src.country"
          />
        </v-col>
        <v-col cols="12" md="3">
          <z-address-autofill
            :label="$i18n.t('PickUp Adress')"
            v-model="cargo.src"
          />
        </v-col>

        <v-col cols="12" md="3">
          <z-consignor-select
            :label="'Consignor'"
            v-model="cargo.consignor"
            type="1"
            :addNewLabel="'Add New Consignor'"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="2">
          <z-country-select
            :label="$i18n.t('Delivery Country')"
            v-model="cargo.dst.country"
          />
        </v-col>
        <v-col cols="12" md="2">
          <z-city-select
            :label="$i18n.t('Delivery City')"
            v-model="cargo.dst.city"
            :country="cargo.dst.country"
          />
        </v-col>
        <v-col cols="12" md="3">
          <z-address-autofill
            :label="$i18n.t('Delivery Adress')"
            v-model="cargo.dst"
          />
        </v-col>
        <v-col cols="12" md="3">
          <z-consignor-select
            :label="$i18n.t('Consignee')"
            v-model="cargo.consignee"
            type="2"
            :addNewLabel="'Add New Consignee'"
          />
        </v-col>

        <v-col cols="12" sm="3" md="2" lg="1">
          <v-btn
            x-small
            fab
            text
            color="red"
            class="my-4 float-right"
            v-if="index != 0"
            @click="cargos.splice(index, 1)"
          >
            <v-icon>mdi-minus-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="py-0 text-body-1">
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            v-model="cargo.lr.number"
            :label="$i18n.t('GRN/LR No.') + '*'"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            v-model="cargo.lr.clientNo"
            :label="$i18n.t('Client GRN/LR No.')"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <z-date-picker v-model="cargo.lr.date" :label="'LR Date'" />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="3">
          <v-text-field
            v-model="cargo.clientRefNo"
            :label="$i18n.t('Client Reference No.')"
          />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="3">
          <v-text-field
            v-model="cargo.miroNo"
            :label="$i18n.t('Miro No.')"
          />
        </v-col>

        <v-col cols="12" sm="3" md="2" lg="2">
          <v-text-field
            v-model="cargo.bidWeight"
            type="number"
            :label="$i18n.t('Bid Weight')"
          />
        </v-col>

        <v-col cols="12" sm="3" md="2" lg="2">
          <v-text-field
            v-model="cargo.bidRate"
            type="number"
            :label="$i18n.t('Bid Price')"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <z-name-master-auto-fill
            :label="$i18n.t('Material')"
            v-model="cargo.material"
            :disabled="!!cargo._id"
            :type="6"
            :addNewLabel="'Add Material'"
            @click.native.stop
          />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            v-model="cargo.units"
            @click.native.stop
            type="number"
            :label="$i18n.t('Quantity') + '/' + $i18n.t('Units')"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            v-model="cargo.chargeWeight"
            type="number"
            :label="$i18n.t('Charge Weight')"
          />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="3">
          <v-row>
            <v-col cols="12" sm="4" md="3" lg="7">
              <v-text-field
                v-model="cargo.weight"
                :disabled="!!cargo._id"
                @click.native.stop
                type="number"
                :label="$i18n.t('Weight')"
              />
            </v-col>

            <v-col cols="12" sm="4" md="3" lg="5">
              <v-select
                v-model="cargo.weightUnit"
                :label="$i18n.t('Unit')"
                :disabled="!!cargo._id"
                @click.native.stop
                type="number"
                item-text="name"
                item-value="value"
                :items="[
                  { name: 'KG', value: 0 },
                  { name: 'Tonnes', value: 1 },
                  { name: 'PCS', value: 2 }
                ]"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="3">
          <v-row>
            <v-col cols="12" sm="4" md="3" lg="7">
              <v-text-field
                :label="$i18n.t('Length')"
                v-model="cargo.length"
                :disabled="!!cargo._id"
                @click.native.stop
                type="number"
              />
            </v-col>
            <v-col cols="12" sm="4" md="3" lg="5">
              <v-select
                v-model="cargo.measureUnit"
                :label="$i18n.t('Unit')"
                :disabled="!!cargo._id"
                @click.native.stop
                type="number"
                item-text="name"
                item-value="value"
                :items="[
                  { name: 'CMS', value: 0 },
                  { name: 'Inches', value: 1 },
                  { name: 'Feet', value: 2 },
                  { name: 'Meter', value: 3 },
                ]"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="3">
          <v-text-field
            v-model="cargo.lr.wayBillNo"
            :label="$i18n.t('E-Waybill No')"
        /></v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <z-date-picker
            v-model="cargo.lr.billIssueDate"
            :label="'E-Way Issue Date'"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2">
          <z-date-picker
            v-model="cargo.lr.billExpiryDate"
            :label="'E-Way Expiration Date'"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <z-date-picker
            v-model="cargo.lr.invoiceDate"
            :label="'Goods Invoice Date'"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="3">
          <v-text-field
            v-model="cargo.lr.invoiceNo"
            :hint="getError(cargo.lr.invoiceNo, errors)"
            persistent-hint
            :label="$i18n.t('Goods Invoice No')"
            @change="reloadError(cargo.lr.invoiceNo)"
        /></v-col>

        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            v-model="cargo.lr.amount"
            :label="$i18n.t('Goods Invoice Value')"
            type="number"
            ><span slot="append" color="purple"> INR </span></v-text-field
          ></v-col
        >
      </v-row>

      <v-row v-if="cargo.lr && cargo.lr.insurance">
        <v-col cols="12" sm="4" md="3" lg="2">
          <z-date-picker
            v-model="cargo.lr.insurance.date"
            :label="$i18n.t('Insurance Date')"
          />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="3">
          <z-name-master-select
            :type="4"
            v-model="cargo.lr.insurance.provider"
            :label="$i18n.t('Insurance Provider')"
          />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="3">
          <v-text-field
            v-model="cargo.lr.insurance.policyNo"
            :label="$i18n.t('Policy No.')"
          />
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="2">
          {{ $i18n.t("Risk") }}
          <v-radio-group
            v-model="cargo.lr.insurance.risk"
            row
            style="margin: 0px"
          >
            <v-radio :label="$i18n.t('High')" :value="1"></v-radio>
            <v-radio :label="$i18n.t('Low')" :value="2"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col cols="12" sm="4" md="3" lg="2">
          <v-text-field
            v-model="cargo.lr.insurance.amount"
            :label="$i18n.t('Insurance Amount')"
            type="number"
            ><span slot="append" color="purple"> INR </span></v-text-field
          ></v-col
        >
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn
            small
            color="blue lighten-1"
            @click="downloadLR('consignor', index, client_id)"
            >{{ $i18n.t("Consignor Copy")
            }}<v-icon>mdi-cloud-download</v-icon></v-btn
          >

          <v-btn
            small
            color="deep-purple lighten-1"
            @click="downloadLR('consignee', index, client_id)"
            >{{ $i18n.t("Consignee Copy")
            }}<v-icon>mdi-cloud-download</v-icon></v-btn
          >

          <v-btn
            small
            color="teal lighten-1"
            @click="downloadLR('office', index, client_id)"
            >{{ $i18n.t("Office Copy")
            }}<v-icon>mdi-cloud-download</v-icon></v-btn
          >
          <v-btn
            small
            color="orange lighten-1"
            @click="downloadLR('driver', index, client_id)"
            >{{ $i18n.t("Driver Copy")
            }}<v-icon>mdi-cloud-download</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </v-card-text>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Cargo",
  props: {
    value: {
      default: null,
    },
    cargoItem: {
      default: null,
    },
    cargos: {
      default: null,
    },
    indexItem: {
      default: null,
    },
    client_id: {
      default: null,
    },
    trip: {
      default: null,
    },
    errors: {
      default: {},
    },
  },
})
export default class Cargo extends Vue {
  cargo = null;
  index = null;

  resetVendorEntity(entity_id) {
    if (this.trip) {
      this.trip.vendorEntity_id = entity_id;
    }
  }

  mounted() {
    this.cargo = this.cargoItem;
    this.index = this.indexItem;
  }

  @Watch("cargoItem")
  onCargoChange(val) {
    this.cargo = val;
  }

  @Watch("cargoItem")
  onIndexChange(val) {
    this.index = val;
  }

  async downloadLR(_for, index, client_id) {
    try {
      common.setLoading(true);
      await doGetWithDownload(
        "/api/trip/" +
          this.trip._id +
          "/receipt/print?_for=" +
          _for +
          "&cargoIndex=" +
          index +
          "&client_id=" +
          client_id
      );
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  getError(invNo, errors) {
    if (errors) {
      const err = errors[invNo];
      if (err) return err;
    }
    return "";
  }

  reloadError(invNo) {
    if (invNo && invNo.length > 3) {
      this.$emit("reloadError", true, invNo);
    }
  }
}
</script>

<style scoped>
.v-text-field__details {
  display: none;
}
.v-input input[type="number"] {
  text-align: right !important;
}

.dense tr td {
  padding: 0 3px !important;
}
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
